import { ReactNode, useEffect } from "react";
import { useOutletContext } from "react-router";

import { IntegrationsOutletContext } from "../types";

export const useLayoutMeta = (metaItems: ReactNode) => {
  const { setLayoutMeta } = useOutletContext<IntegrationsOutletContext>();

  useEffect(() => {
    if (!metaItems) {
      setLayoutMeta(null);
    } else {
      setLayoutMeta(metaItems);
    }

    return () => {
      setLayoutMeta(null);
    };
  }, [metaItems, setLayoutMeta]);
};
